import { useEffect, useRef } from 'react';
import { Space } from 'antd';
import { UploadButton } from 'components/elements';
import { postUploadExcelAPI, postUploadExcelBranchRegionAPI, postUploadExcelPointCartAPI } from 'api/common';
import { postStockBookExcelUploadAPI, postStockProducExcelUploadAPI } from 'api/stock';
import { postMemberExceptionExcelUploadAPI } from 'api/member';

/**
 * uploadMenu 종류: 
 * 1: stockBook (월별 교재 재고관리 업로드용)
 * 2: stockProduct (월별 물품 재고관리 업로드용)
 * 3: pointcart (적립금장바구니 )
 */
export const UploadExcel = ({ text, onChange, onOk, uploadMenu, registerDate=false }) => {
  const fileRef = useRef(null);

  const handleClick = () => {
    if(uploadMenu){
      if( (['stockBook', 'stockProduct'].includes(uploadMenu))
        && !registerDate) {
        alert('일괄등록일을 먼저 선택해주세요.');
      }else{
        fileRef.current.click();
      }
    }
  };

  const handleChange = async (e) => {
    const formData = new FormData();
    formData.append('uploadExcel', e.target.files[0]);

    if (uploadMenu === 'stockBook') { //교재재고관리
      await postStockBookExcelUploadAPI(formData, registerDate)
      .then((res) => {
        const { data } = res;
        if (data?.responseCode === 200) {
          onOk(true);
          alert('등록되었습니다.')
        }
      })
      .catch((err) => {
        console.error(err);
      })
    }else if(uploadMenu === 'stockProduct'){ //물품재고관리 
      await postStockProducExcelUploadAPI(formData, registerDate)
        .then((res) => {
          const { data } = res;
          if (data?.responseCode === 200) {
            onOk(true);
            alert('등록되었습니다.')
          }
        })
        .catch((err) => console.error(err))
        .finally(() => {
          e.target.value = '';
        });
      
    }else if(uploadMenu === 'pointcart'){ //적립금장바구니
      await postUploadExcelPointCartAPI(formData)
        .then((res) => {
          const { data } = res;
          if (data?.responseCode === 200) {
            onOk(true);
            alert('등록되었습니다.')
          }
        })
        .catch((err) => console.error(err))
        .finally(() => {
          e.target.value = '';
        });

    }else if(uploadMenu === 'exceptionApprove'){ //회원관리_예외교습승인
      await postMemberExceptionExcelUploadAPI(formData)
        .then((res) => {
          const { data } = res;
          if (data?.responseCode === 200) {
            onOk(true);
            alert('등록되었습니다.')
          }
        })
        .catch((err) => console.error(err))
        .finally(() => {
          e.target.value = '';
        });
      
    } else if (!registerDate) { //엑셀 업로드 공통
      await postUploadExcelAPI(formData)
        .then((res) => {
          const { data } = res;
          if (data?.responseCode === 200) {
            onOk(true);
            alert('등록되었습니다.')
          }
        })
        .catch((err) => console.error(err))
        .finally(() => {
          e.target.value = '';
        });
    }
    
  };

  return (<>
    <input
      type="file"
      ref={fileRef}
      onChange={handleChange}
      style={{ display: 'none' }}
    />
    <Space wrap={true}>
      <UploadButton text={text} onClick={handleClick} />
    </Space>
  </>)
};

//지역관리 지사 엑셀 업로드전용
export const UploadExcelBranchRegion = ({ text, onChange, onOk}) => {
  console.log("진입!!!!!")
  const fileRef = useRef(null);

  const handleClick = () => {
    fileRef.current.click();
  };
  const handleChange = async (e) => {
    const formData = new FormData();
    formData.append('uploadExcel', e.target.files[0]);
    await postUploadExcelBranchRegionAPI(formData)
      .then((res) => {
        const { data } = res;
        if (data?.responseCode === 200) {
          alert('등록되었습니다.')
          onOk(true);
        }
      })
      .catch((err) => console.error(err))
      .finally(() => {
        e.target.value = '';
      });
    
  };

  return (<>
    <input
      type="file"
      ref={fileRef}
      onChange={handleChange}
      style={{ display: 'none' }}
    />
    <Space wrap={true}>
      <UploadButton text={text} onClick={handleClick} />
    </Space>
  </>)
};